import {
  Criterion,
  CriterionListItem,
  FieldChoice,
  ParticipantField,
} from '@app/api';

export enum ChoiceAllowance {
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
  TOLERATED = 'TOLERATED',
  AUTOMATICALLY_ACCEPTED = 'AUTOMATICALLY_ACCEPTED',
}

export abstract class ICriterionHandler {
  abstract handleCriterion(criterion: Criterion): boolean;

  abstract criterionHandleOthers(): boolean;

  getChoiceAllowance(
    criterion: Criterion,
    choice: FieldChoice,
  ): ChoiceAllowance {
    if (this.listIncludes(criterion.denyList, criterion, choice)) {
      return ChoiceAllowance.DECLINED;
    }

    if (criterion.allowList) {
      if (!this.listIncludes(criterion.allowList, criterion, choice)) {
        return ChoiceAllowance.TOLERATED;
      }
    }

    if (
      criterion.automaticlyAcceptedList &&
      this.listIncludes(criterion.automaticlyAcceptedList, criterion, choice)
    ) {
      return ChoiceAllowance.AUTOMATICALLY_ACCEPTED;
    }
    return ChoiceAllowance.ACCEPTED;
  }

  declineChoice(criterion: Criterion, choice: FieldChoice): Criterion {
    throw new Error('Not available for this criterion type');
  }

  acceptChoice(criterion: Criterion, choice: FieldChoice): Criterion {
    throw new Error('Not available for this criterion type');
  }

  tolerateChoice(criterion: Criterion, choice: FieldChoice): Criterion {
    throw new Error('Not available for this criterion type');
  }

  removeChoice(criterion: Criterion, choice: FieldChoice): Criterion {
    throw new Error('Not available for this criterion type');
  }

  automaticallyAcceptChoice(
    criterion: Criterion,
    choice: FieldChoice,
  ): Criterion {
    throw new Error('Not available for this criterion type');
  }

  areItemListEquals(item1?: CriterionListItem, item2?: CriterionListItem) {
    return item1 === item2;
  }

  abstract handleParticipantField(field: ParticipantField): boolean;

  abstract createEmptyCriterionFromParticipantField(
    field: ParticipantField,
  ): Criterion;

  abstract setCriterionValues(
    criterion: Criterion,
    values?: CriterionListItem[],
    choices?: FieldChoice[],
  ): Criterion;

  protected listIncludes(
    list: CriterionListItem[],
    criterion: Criterion,
    choice: FieldChoice,
  ) {
    for (const item of list) {
      if (this.compareValues(item, choice)) {
        return true;
      }
    }
    return false;
  }

  protected compareValues(item: CriterionListItem, choice: FieldChoice) {
    return item === choice.ref;
  }
}
